var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamMusicvideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.999v10l-6-3v-4l6-3zm-6-2.499c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5zm-12.5-3.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5zm9 9c-1.858 0-3.504-.926-4.5-2.341-.996 1.415-2.642 2.341-4.5 2.341-.521 0-1.022-.078-1.5-.213v4.713c0 .829.672 1.5 1.5 1.5h9c.828 0 1.5-.671 1.5-1.5v-4.713c-.478.135-.979.213-1.5.213zm-3.117 8h-2.766l-5.588 5.586 1.414 1.414 4.557-4.556v4.553h2v-4.553l4.557 4.556 1.414-1.414-5.588-5.586z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamMusicvideo);
export default __webpack_public_path__ + "static/media/stream-musicvideo.1638543a8d6770206a9803991df36f14.svg";
export { ForwardRef as ReactComponent };